<template>
  <section
    id="checkoutReviewOrder"
    :class="['open', emptyCartClass, 'expandable_section', 'review-section']"
  >
    <h2
      class="expandable_header"
    >
      {{ $t('checkout.payment.reviewOrder') }}
    </h2>

    <div class="expandable_content">
      <Cart
        @amount-update="updateStatePaymentFields"
        @updateorder="updateOrder($event)"
      />
    </div>
  </section>
</template>

<script>
import Cart from '../cart/cart'
import { mapMutations, mapState } from 'vuex'

export default {
  components: {
    Cart
  },

  props: {
    number: {
      type: Number,
      default: 0
    },
    updateorder:{
      type: Function,
      default: null
    }
  },

  data() {
    return {
      cartHasItems: true,
      sectionName: 'review',
      sectionNext: 'payment',
    }
  },

  computed: {
    ...mapState('checkout', {
      section: state => state.section
    }),
    emptyCartClass() {
      return (this.cartHasItems) ? '' : 'empty'
    }
  },

  methods: {
    ...mapMutations('checkout', ['updatePaymentFields']),
    updateStatePaymentFields(newFields) {
      if (newFields.itemCount > 0) {
        this.cartHasItems = true
      } else {
        this.cartHasItems = false
      }

      this.updatePaymentFields(newFields)
    },
    updateOrder(order){
      this.$emit('updateorder', order)
    }
  }
}
</script>
